import { ActionTypes as types, forms } from 'constants';
import { Auth } from 'utils';
import { submitFormToProfile, logError } from 'actions';
import {
  resetAppErrors,
  updatePostAppError,
} from 'actions/setters/updateAppErrors';

const log = { component: 'updateNotifications' };

export default values => dispatch => {
  const userGuid = Auth.getUserGuid();
  const canContact = Boolean(values.CanContact);
  const notificationsResource = 'user-status/consent';
  const body = { canContact };

  const onSuccess = () => {
    dispatch({
      type: types.UPDATE_NOTIFICATIONS,
      payload: canContact,
    });
    dispatch(resetAppErrors());
  };

  const onError = error => {
    dispatch(updatePostAppError(error));
    dispatch(logError(types.UPDATE_APP_STATUS_POST_ERROR, { ...log, error }));
  };

  return dispatch(
    submitFormToProfile(
      forms.Notifications,
      notificationsResource,
      userGuid,
      body,
      { clearForm: false, onSuccess, onError },
    ),
  );
};
